'use strict';

var React = require('react');

var SvgShippingLabelFilledIcon = function SvgShippingLabelFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 3.25a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-12a1 1 0 0 0-1-1h-10Zm2 2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2Zm0 4.5a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6Zm1 3.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 1.5 0Zm2.75 1v-1a.75.75 0 0 0-1.5 0v1a.75.75 0 0 0 1.5 0Zm2.75-1v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 1.5 0Z"
  }));
};
SvgShippingLabelFilledIcon.displayName = "ShippingLabelFilledIcon";

exports.SvgShippingLabelFilledIcon = SvgShippingLabelFilledIcon;
